module.exports = __webpack_public_path__ + "img/youtube.65e928a8.png";